import React, { useState } from 'react';
import { D20Icon } from '../primitives/icons';

export const DemoCampaignCard = ({ theme, density, palette, onHoverChange, onOpenDemo }) => {
  const c = theme.colors;
  const t = theme.typography || {};
  const e = theme.effects || {};
  const [hovered, setHovered] = useState(false);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onOpenDemo}
      onKeyDown={(ev) => {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          onOpenDemo && onOpenDemo();
        }
      }}
      onMouseEnter={() => { setHovered(true); onHoverChange && onHoverChange(true); }}
      onMouseLeave={() => { setHovered(false); onHoverChange && onHoverChange(false); }}
      style={{
        background: c.bgCardSolid,
        border: `1px solid ${hovered ? `${palette.color}66` : c.borderLight}`,
        borderRadius: e.borderRadiusLg || '12px',
        padding: density.spacing.cardPadding,
        marginBottom: density.spacing.cardGap,
        boxShadow: hovered
          ? `0 12px 28px rgba(0,0,0,0.55), 0 0 20px ${palette.glow}`
          : (e.cardShadow || '0 4px 16px rgba(0,0,0,0.4)'),
        transform: hovered ? 'translateY(-2px)' : 'none',
        transition: e.transition || 'all 200ms ease',
        cursor: 'pointer',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
        <D20Icon size={40} />
        <div style={{ flex: 1 }}>
          <div style={{
            fontSize: '0.62rem',
            letterSpacing: '0.22em',
            color: palette.light,
            textTransform: 'uppercase',
            marginBottom: 4,
            fontWeight: 700,
            fontFamily: t.fontFamily,
          }}>New Here?</div>
          <div style={{
            fontFamily: t.headingFamily || 'Georgia, serif',
            fontSize: '1.15rem',
            color: c.accentLight,
            marginBottom: 6,
            fontWeight: 600,
            textShadow: e.headingTextShadow,
          }}>Try the Demo Campaign</div>
          <div style={{
            color: c.textSecondary,
            fontSize: '0.82rem',
            lineHeight: 1.5,
            marginBottom: 12,
            fontFamily: t.fontFamily,
          }}>
            Four pre-built characters. No signup.
          </div>
          <button
            onClick={(ev) => {
              ev.stopPropagation();
              onOpenDemo && onOpenDemo();
            }}
            style={{
              padding: '8px 16px',
              background: hovered ? palette.bgStrong || palette.bg : palette.bg,
              border: `1px solid ${palette.border}`,
              borderRadius: e.borderRadiusSm || '4px',
              color: palette.light,
              fontSize: '0.8rem',
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: t.fontFamily,
              transition: e.transition || 'all 200ms ease',
            }}
          >Open demo →</button>
        </div>
      </div>
    </div>
  );
};
